// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".delete-spv-node[data-v-6d6262ab] .el-dialog{width:var(--common-dialog-medium-width)}", ""]);
// Exports
module.exports = exports;
